import { render, staticRenderFns } from "./SelfieInstructionsView.vue?vue&type=template&id=375d6fd1&scoped=true"
import script from "./SelfieInstructionsView.vue?vue&type=script&lang=js"
export * from "./SelfieInstructionsView.vue?vue&type=script&lang=js"
import style0 from "./SelfieInstructionsView.vue?vue&type=style&index=0&id=375d6fd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375d6fd1",
  null
  
)

export default component.exports